import {Component, OnInit, OnDestroy, TemplateRef, ViewChild, Input} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {TemplateService} from '../../services/template.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../../services/constant';
import {SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {SubSink} from 'subsink';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

const PERCENT_EXTRA_CC_EMAIL: ReadonlyArray<string> = [
  'ubonwan@chod.co.th', 'natha@chod.co.th', 'residence@chod.co.th', 'sasithorn@chod.co.th',
];

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [TemplateService]
})
export class SearchComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;

  selectedCompany: SelectItem[];
  company: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  allBranch = true;
  allDocType = true;
  branch: any;
  selectedBranch: SelectItem[];
  allBranchList: any = null;
  branchSuggest: any;
  branchList: any = null;
  docTypeList: any = null;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allBranchSelected = [];
  rdDocumentType: any;
  selectedRdDocumentType: any;
  remark: any;

  selectedType: any;
  inputText: any;
  buyerNameText: any;
  buyerTaxID: any;
  tableData: any;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  totalItems = 0;
  selectedValues = [];
  currentPage = 1;
  checked = false;
  url: any;
  date: Date;
  docTypes: any;
  loading = false;
  loadingZip = false;
  errorMsg = '';

  calendarLocale = CALENDAR_LOCALE.TH;
  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  resendEmailSmsMessage = '';
  isLoadingMessage = '';
  isSending = false;

  loading_all_zip_progress = 0;
  tableArray: any[] = [];

  modal: NgbModalRef;
  allZipCount: number;
  allZipCurrent = 0;

  sortBy: string;
  sortMode: string;

  canDownloadXml = false;
  canDeleteInvoice = false;
  canDeleteTaxDocument = false;
  canSendEmail = false;
  countOther = 0;
  countNonOther = 0;
  canSendEmailSMS = false;
  canDownloadCSV = false;

  commentList = [];
  showResult = false;
  newComment = '';
  subscription: Subscription;
  owner = localStorage.username;
  taxId = null;
  currentComment: number = null;

  statusSearch: any = null;
  locationSearch = [];
  overdueStatusSearch = [];
  selectedStatus: SelectItem[];
  selectedLocation: SelectItem[];
  selectedOverdueStatus: SelectItem[];

  isResend = false;
  resendFirst = false;
  resendSecond = false;
  buyerEmail = [{value: ''}];
  buyerEmailCheckList = [];
  canResendFirst = false;
  canResendSecond = false;
  resendFirstNotify = false;
  resendSecondNotify = false;
  firstEmailNotify = false;
  firstSmsNotify = false;
  secondEmailNotify = false;
  secondSmsNotify = false;
  canDownloadInvoicePdf = false;
  paymentType = [];
  additionalDownloadPdf = null;
  isLoadingMessageResend = '';
  isLoadingCsv = false;
  loadingCsvMessage = '';
  countCsvFile = null;
  commentDeleteType = 'trash-icon';
  invoiceDeleteType = 'invoice-delete';


  photo = '../../../assets/images/icons/person-placeholder.png';

  tableCol = [
    {field: 'invoice_number', header: 'เลขที่เอกสาร'},
    {field: 'buyer_name', header: 'ชื่อลูกค้า'},
    {field: 'reference_ref_location', header: 'Location'},
    {field: 'header_issue_date', header: 'วันที่ออกเอกสาร'},
    // {field: 'branch', header: 'ชื่อสาขา'},
    {field: 'rd_doc_type', header: 'ประเภทเอกสาร'},
    // { field: 'buyer_name', header: 'ชื่อผู้ซื้อ' },
    {field: 'receipt_no', header: 'เลขที่ Receipt No.'},
    {field: 'total_items_total_payment', header: 'ยอดขาย'},
    {field: 'additional_data.status', header: 'สถานะ'},
    {field: 'additional_data.overdue_balance', header: 'ยอดเงินคงค้าง'},
    {field: 'additional_data.due_date_diff', header: 'จำนวนวันที่ค้างชำระ'},
    {field: 'additional_data.overdue_status', header: 'สถานะ'},
    {field: '', header: 'การแจ้งเตือน'},
    {
      field: 'additional_data.first_email_notified'
        && 'additional_data.first_sms_notified', header: 'แจ้งเตือนครั้งที่ 1'
    },
    {
      field: 'additional_data.second_email_notified'
        && 'additional_data.second_sms_notified', header: 'แจ้งเตือนครั้งที่ 2'
    },
    {field: '', header: 'กล่องข้อความ'},
  ];
  ccEmail = [
    {ccEmailList: 'pirada@chod.co.th'}
  ];
  ccEmailcheckList = [];

  // edit document variables
  confirmModal: NgbModalRef;
  clickedSubmit: boolean;
  selectedDocument: any;
  amountBefore: number;
  amountAfter: string;
  statusBefore: string;
  statusAfter: string;
  statusChoices = [
    {label: 'ชำระครบหมดแล้ว', value: 'full_payment'},
    {label: 'ค้างชำระเต็มจำนวน', value: 'full_amount_owed'},
    {label: 'ชำระแล้วบางส่วน', value: 'partial_payment'},
    {label: 'ไม่มีการแสดงสถานะ', value: 'cancelled'},
  ]

  statusDropdownChoices = [
    {label: 'ค้างชำระเต็มจำนวน', value: 'full_amount_owed'},
    {label: 'ชำระแล้วบางส่วน', value: 'partial_payment'},
    {label: 'ชำระครบหมดแล้ว', value: 'full_payment'},
  ]

  @ViewChild('content2') resultContentModal: any;

  private subs = new SubSink();

  constructor(
    private apiService: ApiService,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private template: TemplateService,
  ) {
  }

  ngOnInit() {
    this.loadInput();
    // this.loadDropdown();
    this.rdDocumentType = this.template.getDropdown();
  }

  loadInput() {
    this.company = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getCompany().subscribe(result => {
        _.forEach(result, obj => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
      })
    );

    this.homeproGroup = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getCompanyGroup().subscribe(result => {
        _.forEach(result, obj => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          });
        });
      })
    );

    // this.subs.add(
    //   this.apiService.getBranch().subscribe(result => {
    //     this.allBranchList = result;
    //     this.filterBranchList();
    //   })
    // );

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.dropdownStatus();

  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  // filterBranchList() {
  //   this.selectedBranch = null;
  //
  //   this.branchList = [
  //     {
  //       label: 'ทั้งหมด',
  //       value: null
  //     }
  //   ];
  //
  //   _.forEach(this.allBranchList, obj => {
  //     if (this.selectedCompany == null || obj.corporate === this.selectedCompany) {
  //       this.branchList.push({
  //         label: obj.full_name,
  //         value: obj.id
  //       });
  //     }
  //   });
  // }

  searchBranch(event) {
    if (this.branchList == null) {
      this.subs.add(
        this.apiService.getBranch().subscribe(data => {
          this.branchList = data;
          this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        })
      );
    } else {
      this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.subs.add(
        this.apiService.getDocumentType().subscribe(result => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        })
      );
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
    }
  }

  selectAllBranch() {
    this.branch = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  clearBranch() {
    this.allBranchSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim();

    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      const data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  loadDropdown() {
    this.docTypes = this.template.getDropdown();
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.tableData = []
    this.loadData(params);
    this.canDownloadXml = false;
    // this.canDownloadCSV = false;
    this.canDeleteInvoice = false;
    this.canSendEmail = false;
    this.canDeleteTaxDocument = false;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  clearSearch() {
    this.selectedType = null;
    this.inputText = null;
    this.selectedCompany = null;
    this.selectedHomeproGroup = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.selectedBranch = null;
    this.selectedRdDocumentType = null;
    this.buyerNameText = null;
    this.buyerTaxID = null;
    this.selectedStatus = null;

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.canDownloadXml = false;
    this.canDownloadCSV = false;
    this.canDeleteInvoice = false;
    this.canDeleteTaxDocument = false;
    this.canSendEmail = false;
    this.countNonOther = 0;
    this.countOther = 0;
    this.searchButtonClicked();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.countNonOther = 0;
    this.countOther = 0;
    this.sortBy = null;
    this.sortMode = null;
    this.disableButton();
    this.loadData();
  }

  disableButton() {
    this.canSendEmail = false;
    this.canDownloadXml = false;
    // this.canDownloadCSV = false;
    this.canDeleteInvoice = false;
    this.canDeleteTaxDocument = false;
  }

  loadData(params?) {
    this.checkCondition();
    if (this.errorMsg.length > 0) {
      return;
    }

    this.allBranchSelected = [];
    this.allDocumentType = [];
    _.forEach(this.branch, obj => {
      // this.allBranchSelected = [];
      this.allBranchSelected.push(_.toNumber(obj.id));
    });
    _.forEach(this.documentType, obj => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(obj.id));
    });

    const data = {
      rd_doc_type: this.selectedRdDocumentType,
      search_box: this.inputText,
      buyer_tax_id: this.buyerTaxID,
      buyer_name: this.buyerNameText,
      header_issue_date_start:
        this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end:
        this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
      group_id: this.selectedHomeproGroup,
      company_id: this.selectedCompany,
      document_type_id: _.isNil(this.documentType)
        ? this.documentType
        : _.uniq(this.allDocumentType),
      // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
      branch_id: this.selectedBranch ? [this.selectedBranch] : null,
      items_per_page: this.itemsPerPage,
      status: this.selectedStatus,
      location: this.selectedLocation,
      overdue_status: this.selectedOverdueStatus
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.loading = true;

    this.subs.add(
      this.apiService.postSearch(data, params).subscribe((res: any) => {
        this.tableData = res.results;
        this.totalItems = res.count;
        this.selectedValues = [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.selectedValues.push(false);
        }
        this.loading = false;
      })
    );
  }

  loadLocationName() {
    this.locationSearch = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];
    this.subs.add(
      this.apiService.getLocationName().subscribe((res: any) => {

        _.forEach(res.results, obj => {
          this.locationSearch.push({
            label: obj.location_name,
            value: obj.location_name
          });
        });
      })
    )
  }

  dropdownStatus() {
    this.selectedStatus = null;
    this.loadLocationName()
    this.statusSearch = [
      {
        label: 'ทั้งหมด',
        value: null
      },
      {
        label: 'ชำระครบหมดแล้ว',
        value: 'full_payment'
      },
      {
        label: 'ชำระแล้วบางส่วน',
        value: 'partial_payment'
      },
      {
        label: 'ค้างชำระเต็มจำนวน',
        value: 'full_amount_owed'
      },
      {
        label: 'ไม่มีการแสดงสถานะ',
        value: 'no_payment_status_or_cancelled'
      }
    ];
    this.overdueStatusSearch = [
      {
        label: 'ทั้งหมด',
        value: null
      }, {
        label: 'Not overdue',
        value: 'Not overdue'
      }, {
        label: 'Paid',
        value: 'Paid'
      }, {
        label: '1-5 Days',
        value: '1-5 Days'
      }, {
        label: '6-30 Days',
        value: '6-30 Days'
      }, {
        label: '31-60 Days',
        value: '31-60 Days'
      }, {
        label: '61-90 Days',
        value: '61-90 Days'
      }, {
        label: '90+ Days',
        value: '90+ Days'
      },
    ];
  }

  DownloadSelected(content, doc_type) {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i] || this.tableData[i].status === 'cancelled') {
        continue;
      }

      // skip if rd_document_type is `other`
      if (this.tableData[i].rd_document_type === 'other' && doc_type === 'xml') {
        continue;
      }

      this.tableArray.push(this.tableData[i]);
    }

    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;

      if (doc_type === 'xml') {
        this.download(0, this.tableArray, 'xml_file');
        this.sniff('DOWNLOAD_XML', '');
      } else {
        this.download(0, this.tableArray, 'pdf_file');
        this.sniff('DOWNLOAD_PDF', '');
      }
    }
  }

  DeleteSelected(content, isInvoice = true) {
    this.tableArray = [];
    this.tableArray = this.selectedDocuments(isInvoice);
    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;
      this.delete(0, this.tableArray, 'pdf_file');
      // this.sniff('DELETE_INVOICE', '')
    }
  }

  selectedDocuments(isInvoice) {
    return this.selectedValues
      .map((value, index) => {
        if (!value) return null;
        const documentType = this.tableData[index].rd_document_type;
        if (isInvoice && documentType === 'other') {
          return this.tableData[index];
        } else if (!isInvoice && documentType !== 'other') {
          const data = this.tableData[index]
          data.version = 2;
          return data;
        }
        return null;
      })
      .filter(item => item !== null);
  }

  delete(index, tableArray, url_field_name) {
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message =
        'Delete เสร็จสมบูรณ์ (ทั้งหมด ' + tableArray.length + ' รายการ)';
      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const delete_url = tableArray[index][url_field_name];

    // skip if delete url is empty.
    if (delete_url == null || delete_url.length === 0) {
      this.delete(index + 1, tableArray, url_field_name);
      return;
    }

    this.subs.add(
      this.apiService.deleteFileFromMediaPath(tableArray[index]).subscribe(
        obj => {
          if (this.cancel_loading_all_zip) {
            return;
          }

          // this.loading_all_zip = false;
          let filename = this.getFileName(tableArray[index]);

          if (url_field_name === 'xml_file') {
            filename = filename + '.xml';
          } else {
            filename = filename + '.pdf';
          }

          // this.apiService.createDownloadFile(obj, filename);
          this.allZipCurrent++;
          this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
          // data.xmlLoading = false;
          setTimeout(() => {
            this.delete(index + 1, tableArray, url_field_name);
          }, 1000);
        },
        error => {
          this.loading_all_zip = false;
          this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
          // data.xmlLoading = false;
        }
      )
    );
  }

  canDownloadPdf() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }

  canDownloadCsv() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }


  selectIn(checker, data) {

    if (data.rd_document_type === 'other' && checker === true) {
      // this.canDeleteInvoice = this.selectedValues.filter(select => select === true).length > 0;
      this.countOther++;

      if (this.countOther > 0) {
        this.canDeleteInvoice = true;
        this.canSendEmail = true;
      }
      if (this.countOther > 1) {
        this.canSendEmail = false;
      }
    }
    if (data.rd_document_type === 'other' && checker === false) {
      // this.canDeleteInvoice = (data.rd_document_type === "other" && this.selectedValues.filter(select => select === true).length != 0);
      // this.canDeleteInvoice = false;
      this.countOther--;

      if (this.countOther === 0) {
        this.canDeleteInvoice = false;
        this.canSendEmail = false;
        // this.canDownloadCSV = false;
      } else {
        this.canSendEmail = true;
      }
    }

    if (data.rd_document_type !== 'other' && checker === true) {
      // this.canDownloadXml = this.selectedValues.filter(select => select === true).length > 0;
      this.countNonOther++;

      if (this.countNonOther > 0) {
        this.canDownloadXml = true;
        this.canSendEmail = true;
        this.canDeleteTaxDocument = true;
      }
      if (this.countNonOther > 1) {
        this.canSendEmail = false;
      }
    }

    if (data.rd_document_type !== 'other' && checker === false) {
      // this.canDownloadXml = (data.rd_document_type !== "other" && this.selectedValues.filter(select => select === true).length != 0);

      this.countNonOther--;

      if (this.countNonOther === 0) {
        this.canDownloadXml = false;
        // this.canDownloadCSV = false;
        this.canSendEmail = false;
        this.canDeleteTaxDocument = false;
      } else {
        this.canSendEmail = true;
      }
    }
  }


  download(index, tableArray, url_field_name) {
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message =
        'Download เสร็จสมบูรณ์ (ทั้งหมด ' + tableArray.length + ' รายการ)';
      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const download_url = tableArray[index][url_field_name];

    // skip if download url is empty.
    if (download_url == null || download_url.length === 0) {
      this.download(index + 1, tableArray, url_field_name);
      return;
    }

    this.subs.add(
      this.apiService.downloadFileFromMediaPath(download_url).subscribe(
        obj => {
          if (this.cancel_loading_all_zip) {
            return;
          }

          // this.loading_all_zip = false;
          let filename = this.getFileName(tableArray[index]);

          if (url_field_name === 'xml_file') {
            filename = filename + '.xml';
          } else {
            filename = filename + '.pdf';
          }

          this.apiService.createDownloadFile(obj, filename);
          this.allZipCurrent++;
          this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
          // data.xmlLoading = false;
          setTimeout(() => {
            this.download(index + 1, tableArray, url_field_name);
          }, 1000);
        },
        error => {
          this.loading_all_zip = false;
          this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
          // data.xmlLoading = false;
        }
      )
    );
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  getFileName(data) {
    let file_name =
      '' + data.header_invoice_number + '_' + data.rd_document_type + '_' + data.header_issue_dt;
    file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
    return file_name;
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }

  selectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      if (this.tableData[i].status === 'active') {

        this.canDownloadXml = this.selectedValues[i] = true;
        this.canDeleteTaxDocument = this.selectedValues[i] = true;
        // this.canDownloadCSV = this.selectedValues[i] = true;
        // this.canSendEmail = this.selectedValues[i] = true;
      }
      this.canDeleteInvoice = this.selectedValues[i] = true;
    }
    this.countOther = 0;
    this.countNonOther = 0;
    this.tableData.forEach(obj => {
      if (obj.rd_document_type === 'other') {
        this.countOther++;
      } else {
        this.countNonOther++;
      }
    });
  }

  deselectAll() {
    for (let i = 0; i < this.tableData.length; i++) {

      this.canDownloadXml = this.selectedValues[i] = false;
      this.canDeleteInvoice = this.selectedValues[i] = false;
      this.canSendEmail = this.selectedValues[i] = false;
      // this.canDownloadCSV = this.selectedValues[i] = false;
    }
    this.countOther = 0;
    this.countNonOther = 0;

  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push('สาขา');
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = 'กรุณาระบุ ' + errorMsgList.join(', ') + ' ให้ถูกต้อง';
      return;
    }

    // const dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
    // if (dayDiff > 60 && this.authService.isAccountant()) {
    //   this.errorMsg = 'ไม่สามารถเลือกระยะเวลาเกิน 60 วัน';
    // }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subs.unsubscribe();
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  isUIH() {
    return this.authService.isUIH();
  }

  isAccountant() {
    return this.authService.isAccountant();
  }

  isAccountantAdmin() {
    return this.authService.isAccountantAdmin();
  }

  isIT() {
    return this.authService.isIT();
  }

  isViewer() {
    return this.authService.isViewer();
  }

  isViewerAudit() {
    return this.authService.isViewerAudit();
  }

  get isSystemAdmin(): boolean {
    return this.authService.isSystemAdmin() || this.authService.isAdmin();
  }

  get hasRequestDeletePermission() {
    return this.authService.hasRequestDeletePermission();
  }

  get hasRequestEditPermission() {
    return this.authService.hasRequestEditPermission();
  }

  setDefaultCcEmail() {
    // VERY HARD CODE DEFAULT CC PAYMENT AMOUNT AND PERCENTAGE
    // REFERENCE FROM BOOLEAN OF ADDITIONAL_DATA
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      if (this.tableData[i].additional_data.first_email_notified === false
        && this.tableData[i].additional_data.first_sms_notified === false
        && this.tableData[i].additional_data.second_sms_notified === false
        && this.tableData[i].additional_data.second_email_notified === false) {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'}
        ];
      }
      if (this.tableData[i].additional_data.first_email_notified === true
        && this.tableData[i].additional_data.first_sms_notified === true
        && this.tableData[i].additional_data.second_sms_notified === false
        && this.tableData[i].additional_data.second_email_notified === false) {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'}
        ];
      }
      if (this.tableData[i].additional_data.first_sms_notified === false
        && this.tableData[i].additional_data.first_email_notified === false
        && this.tableData[i].additional_data.second_email_notified === true
        && this.tableData[i].additional_data.second_sms_notified === true
        && this.tableData[i].additional_data.payment_type === 'amount') {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'},
          {ccEmailList: 'admin_operation@chod.co.th'},
        ];
      }
      if (this.tableData[i].additional_data.first_sms_notified === true
        && this.tableData[i].additional_data.first_email_notified === true
        && this.tableData[i].additional_data.second_email_notified === true
        && this.tableData[i].additional_data.second_sms_notified === true
        && this.tableData[i].additional_data.payment_type === 'amount') {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'},
          {ccEmailList: 'admin_operation@chod.co.th'},
        ];
      }
      if (this.tableData[i].additional_data.first_sms_notified === false
        && this.tableData[i].additional_data.first_email_notified === false
        && this.tableData[i].additional_data.second_email_notified === true
        && this.tableData[i].additional_data.second_sms_notified === true
        && this.tableData[i].additional_data.payment_type === 'percentage') {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'},
          {ccEmailList: 'admin_operation@chod.co.th'},
          {ccEmailList: 'ubonwan@chod.co.th'},
          // {ccEmailList: 'prissana@foodiebangna.com'},
        ];
      }
      if (this.tableData[i].additional_data.first_sms_notified === true
        && this.tableData[i].additional_data.first_email_notified === true
        && this.tableData[i].additional_data.second_email_notified === true
        && this.tableData[i].additional_data.second_sms_notified === true
        && this.tableData[i].additional_data.payment_type === 'percentage') {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'},
          {ccEmailList: 'admin_operation@chod.co.th'},
          {ccEmailList: 'ubonwan@chod.co.th'},
          // {ccEmailList: 'prissana@foodiebangna.com'},
        ];
      }
      // Only Foodie sent first email and sms
      if (this.tableData[i].additional_data.first_email_notified === false
        && this.tableData[i].additional_data.first_sms_notified === false
        && this.tableData[i].additional_data.second_sms_notified === true
        && this.tableData[i].additional_data.second_email_notified === true
        && this.tableData[i].is_foodie === true) {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'},
          {ccEmailList: 'admin_operation@chod.co.th'},
          {ccEmailList: 'ubonwan@chod.co.th'},
          {ccEmailList: 'prissana@foodiebangna.com'},
          {ccEmailList: 'chatanunrojwong@foodiebangna.com'},
          {ccEmailList: 'passakorn.na@foodiebangna.com'},
          {ccEmailList: 'suthamas.su@foodiebangna.com'}
        ];
      }
      // Only Foodie sent second email and sms
      if (this.tableData[i].additional_data.first_email_notified === true
        && this.tableData[i].additional_data.first_sms_notified === true
        && this.tableData[i].additional_data.second_sms_notified === true
        && this.tableData[i].additional_data.second_email_notified === true
        && this.tableData[i].is_foodie === true) {
        this.ccEmail = [
          {ccEmailList: 'pirada@chod.co.th'},
          {ccEmailList: 'admin_operation@chod.co.th'},
          // {ccEmailList: 'ubonwan@chod.co.th'},
          {ccEmailList: 'prissana@foodiebangna.com'},
          {ccEmailList: 'chatanunrojwong@foodiebangna.com'},
          {ccEmailList: 'passakorn.na@foodiebangna.com'},
          {ccEmailList: 'suthamas.su@foodiebangna.com'}
        ];
      }
      // Percentage reminders (1st and 2nd) also CC these, except Foodie; keep in sync with PERCENT_EXTRA_CC_EMAIL
      if (this.tableData[i].additional_data.payment_type === 'percentage' && this.tableData[i].is_foodie !== true) {
        const current = this.ccEmail.map(cc => cc.ccEmailList);
        PERCENT_EXTRA_CC_EMAIL
          .filter(email => !current.includes(email))
          .forEach(email => this.ccEmail.push({ccEmailList: email}));
      }
    }
    // }
  }

  askEmailType(content) {
    // REFERENCE FROM BOOLEAN OF ADDITIONAL_DATA
    this.mapPaymentType();
    this.setDefaultCcEmail();
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      if (this.tableData[i].additional_data.first_email_notified
        && this.tableData[i].additional_data.first_sms_notified === true) {
        this.resendFirstNotify = true;
      }
      if (this.tableData[i].additional_data.second_email_notified
        && this.tableData[i].additional_data.second_sms_notified === true) {
        this.resendSecondNotify = true;
      }

    }
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
  }

  closeAskEmailTypeModal() {
    this.modal.close();
    this.ccEmail = [];
    this.buyerEmail = [{value: ''}];
    this.remark = null;
    this.resendFirstNotify = false;
    this.resendSecondNotify = false;
  }

  mapPaymentType() {
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      this.paymentType = this.tableData[i].additional_data.payment_type;
    }
  }

  sendEmailSelected(content, overdue) {
    this.tableArray = [];
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      this.tableArray.push(this.tableData[i].id);
    }
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
    this.isLoadingMessage = 'โปรดรอสักครู่';
    this.isSending = true;
    const data = {
      tax_data_id_list: this.tableArray,
      overdue: overdue,
    };
    this.subs.add(
      this.apiService.resendEmailSms(data).subscribe(
        (result) => {
          this.isSending = false;
          this.resendEmailSmsMessage = 'ส่ง E-mail และ SMS สำเร็จแล้ว';
          this.remark = result;
          this.sniff('SEND_EMAIL_AND_SMS', '');
        },
        (error) => {
          this.isSending = false;
          this.resendEmailSmsMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        }
      )
    );
  }

  resendEmailSelected(content, resend) {
    // map default cc email and buyeremail to send api
    this.tableArray = [];
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      this.tableArray.push(_.toNumber(this.tableData[i].id));
    }
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
    this.isLoadingMessageResend = 'โปรดรอสักครู่';
    this.ccEmailcheckList = [];
    this.buyerEmailCheckList = [];
    this.buyerEmail.map(res => {
      this.buyerEmailCheckList.push(res.value);
      if (res.value === '') {
        return this.buyerEmailCheckList = [];
      }
    });
    this.ccEmail.map(res => {
      this.ccEmailcheckList.push(res.ccEmailList);
    });
    this.isResend = true;
    this.resendFirst = true;
    this.resendSecond = resend;
    const data = {
      tax_data_id: this.tableArray,
      is_resend: this.isResend,
      resend_first: this.resendFirst !== this.resendSecond ? this.resendSecond = false : this.resendFirst === true,
      resend_second: !this.resendSecond,
      buyer_email: this.buyerEmailCheckList,
      cc_email: this.ccEmailcheckList
    };
    this.subs.add(
      this.apiService.resendEmailSmsNotify(data).subscribe(
        () => {
          this.isResend = false;
          this.resendEmailSmsMessage = 'ส่ง E-mail และ SMS สำเร็จแล้ว';
        },
        (error) => {
          this.isResend = false;
          this.resendEmailSmsMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        }
      )
    );
  }

  closeSendEmailSmsModal() {
    this.modal.close();
    this.remark = null;
  }

  addDetailEmail() {
    this.buyerEmail.push({value: ''});
  }

  removeDetailEmail() {
    this.buyerEmail.pop();
  }

  openOverdueNotification(content, data) {
    // REFERENCE FROM BOOLEAN OF ADDITIONAL_DATA
    this.paymentType = [];
    this.paymentType = data.additional_data.payment_type;
    this.additionalDownloadPdf = data.additional_data.invoice_payment_pdf_file;
    if (data.additional_data.first_email_notified === true) {
      this.firstEmailNotify = true;
    }
    if (data.additional_data.first_sms_notified === true) {
      this.firstSmsNotify = true;
    }
    if (data.additional_data.second_email_notified === true) {
      this.secondEmailNotify = true;
    }
    if (data.additional_data.second_email_notified === true) {
      this.secondSmsNotify = true;
    }
    if (this.firstEmailNotify && this.firstSmsNotify && this.secondEmailNotify &&
      this.secondSmsNotify === true) {
      this.canDownloadInvoicePdf = true;
    }
    if (this.additionalDownloadPdf === '') {
      this.canDownloadInvoicePdf = false;
    }
    if (data.additional_data.overdue_balance === 0) {
      this.canDownloadInvoicePdf = false;
    }
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
  }

  closeOverdueNotification() {
    this.modal.close();
    this.firstEmailNotify = false;
    this.firstSmsNotify = false;
    this.secondEmailNotify = false;
    this.secondSmsNotify = false;
    this.additionalDownloadPdf = null;
    this.canDownloadInvoicePdf = false;
  }

  openCommentBox(taxData, content) {
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
    this.taxId = taxData.id;
    this.getCommentList();
  }

  getCommentList() {
    const params = new HttpParams()
      .set('tax_data', this.taxId)
      .set('none_pagination', 'true');
    this.subs.add(
      this.apiService.getCommentList(params).subscribe((comments: any) => {
        this.commentList = comments;
        this.showResult = true;
        this.sniff('GET_COMMENT', '');
      })
    );
  }

  addComment(newComment) {
    // from memo comment
    if (newComment[0].newComment == null || newComment[0].newComment.trim().length === 0) {
      return;
    }
    const profileUser = (localStorage.getItem('username'));
    const fd = {
      'tax_data': this.taxId,
      'message': newComment[0].newComment || '',
      'created_username': profileUser.toString(),
    };
    this.apiService.createNewComment(fd).subscribe(comment => {
      this.commentList.push(comment);
      newComment = [];
    });
  }

  isOwner(stream) {
    return this.owner === stream.created_username;
  }

  deleteComment(commentId) {
    // from memo comment
    this.apiService.deleteComment(commentId).subscribe(
      () => (this.commentList = this.commentList.filter(stream => stream.id !== commentId)));
  }

  downloadCsvReport(content) {
    this.tableArray = [];
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      this.tableArray.push(this.tableData[i].id);
    }
    const data = {
      tax_id: this.tableArray,
      company_id: this.selectedCompany,
      rd_doc_type: this.selectedRdDocumentType,
      doc_no: this.inputText,
      buyer_tax_id: this.buyerTaxID,
      buyer_name: this.buyerNameText,
      header_issue_date_start:
        this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end:
        this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
      document_type_id: _.isNil(this.documentType)
        ? this.documentType
        : _.uniq(this.allDocumentType),
      // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
      status: this.selectedStatus,
      location: this.selectedLocation,
      overdue_status: this.selectedOverdueStatus
    };
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
    this.isLoadingCsv = true;
    this.loadingCsvMessage = 'กำลังดาวน์โหลดไฟล์ CSV';
    this.countCsvFile = this.tableArray.length;
    this.subs.add(
      this.apiService.exportCsvReport(data).subscribe(
        res => {
          const filename = 'csv-' + moment().format('DD-MM-YYYY');
          this.apiService.createDownloadFile(res, filename);
          this.isLoadingCsv = false;
          this.loadingCsvMessage = 'ดาวน์โหลดไฟล์ CSV เสร็จสิ้น';
          this.sniff('DOWNLOAD_CSV', filename);
        }
      )
    );
  }

  downloadAdditionalPdf() {
    const download_url = this.additionalDownloadPdf;
    this.subs.add(
      this.apiService.downloadFileFromMediaPath(download_url).subscribe(
        pdf => {
          const filename = 'แจ้งเตือนชำระหนี้ค้าง.pdf';
          this.apiService.createDownloadFile(pdf, filename);
        },
      )
    );
  }

  getDeleteMessageConfirm(request = false): string {
    this.tableArray = [];
    this.tableArray = this.selectedDocuments(false);
    const documentNumbers = this.tableArray.map(item => `${item.header_invoice_number} (บริษัท ${item.corporate_branch__corporate__name})`);

    return request
      ? 'คุณแน่ใจหรือไม่ที่จะขอลบเอกสารฉบับนี้<br>* ' + documentNumbers.join('<br>* ')
      : 'คุณแน่ใจหรือไม่ที่จะลบเอกสารฉบับนี้<br>* ' + documentNumbers.join('<br>* ')
  }

  RequestDeleteSelected() {
    const taxDataId = this.selectedDocuments(false).map((item) => item.id);
    const payload = {
      tax_data: taxDataId,
      request_type: 'delete_document',
    }
    this.apiService.createDocumentRequest(payload).pipe(
      finalize(() => {
        this.loading_all_zip = false;
        this.modal = this.modalService.open(this.resultContentModal);
      }),
    ).subscribe(
      () => {
        this.loading_all_zip_message = 'ส่งคำขอสำเร็จ'
      },
      (error) => {
        this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
      },
    );
  }

  openEditDocumentModal(contentModal, data) {
    this.selectedDocument = data;
    this.statusBefore = this.statusChoices.find((item) => item.value === data.additional_data.status).label || 'ไม่มีการแสดงสถานะ';
    this.amountAfter = data.additional_data.overdue_balance.toString();
    this.statusAfter = data.additional_data.status !== 'full_payment' ? data.additional_data.status : '';
    this.modal = this.modalService.open(contentModal, {
      centered: true,
      size: 'lg'
    });
  }

  validDecimal(input): boolean {
    if (!input) {
      return false;
    }
    const isDecimalOrThousandSeparated = input.match(/^\d{1,3}(,\d{3})*(\.\d+)?$/);
    const isNormalNumber = input.match(/^\d+(\.\d+)?$/)
    return isDecimalOrThousandSeparated !== null || isNormalNumber !== null;
  }

  validAmountAfterAndStatusAfter(amountAfter, statusAfter): boolean {
    if (!statusAfter) {
      return true;
    }

    if (statusAfter === 'full_payment' && amountAfter !== '0') {
      return false;
    }

    return true;
  }

  get validEditDocumentForm(): boolean {
    if (!this.selectedDocument) {
      return false;
    }

    if (!this.amountAfter && !this.statusAfter) {
      return false;
    }

    if (this.amountAfter && !this.validDecimal(this.amountAfter)) {
      return false;
    }

    if (!this.validAmountAfterAndStatusAfter(this.amountAfter, this.statusAfter)) {
      return false;
    }

    return true
  }

  editDocument() {
    const payload = {
      tax_data: this.selectedDocument.id,
      amount_before: this.selectedDocument.additional_data.overdue_balance,
      amount_after: this.amountAfter ? this.amountAfter.replace(/,/g, '').replace(/ /g, '') : '',
      status_before: this.selectedDocument.additional_data.status,
      status_after: this.statusAfter || '',
    }
    this.apiService.editDocument(payload).pipe(
      finalize(() => {
        this.loading_all_zip = false;
        this.modal = this.modalService.open(this.resultContentModal, {
          centered: true,
        });
      }),
    ).subscribe(
      () => {
        this.closeModal();
        this.loading_all_zip_message = 'แก้ไขสำเร็จ'
      },
      (error) => {
        this.closeModal();
        this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
      },
    );
  }

  requestEditDocument() {
    const payload = {
      tax_data: [this.selectedDocument.id],
      request_type: 'edit_document',
      details: {
        amount_before: this.selectedDocument.additional_data.overdue_balance,
        amount_after: this.amountAfter ? this.amountAfter.replace(/,/g, '').replace(/ /g, '') : '',
        status_before: this.selectedDocument.additional_data.status,
        status_after: this.statusAfter || '',
      }
    }
    this.apiService.createDocumentRequest(payload).pipe(
      finalize(() => {
        this.loading_all_zip = false;
        this.modal = this.modalService.open(this.resultContentModal, {
          centered: true,
        })
      }),
    ).subscribe(
      () => {
        this.closeModal();
        this.loading_all_zip_message = 'ส่งคำขอสำเร็จ'
      },
      (error) => {
        this.closeModal();
        this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
      },
    );
  }

  closeModal() {
    this.modal.close();
    this.closeConfirmModal();
    this.amountAfter = undefined;
    this.statusAfter = undefined;
    this.selectedDocument = undefined;
    this.clickedSubmit = false;
  }

  openConfirmModal(contentModal) {
    this.clickedSubmit = true;
    if (!this.validEditDocumentForm) {
      return;
    }
    this.confirmModal = this.modalService.open(contentModal, {
      centered: true,
    });
  }

  closeConfirmModal() {
    this.confirmModal.close();
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'DOCUMENT_SEARCH',
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.ts